// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__+pkua","sk-rotate":"Loader_sk-rotate__0dggK","dot1":"Loader_dot1__ECpRu","dot2":"Loader_dot2__nINIb","sk-bounce":"Loader_sk-bounce__fwtcv"};